{
  "stats": {
    "view_count": "今日浏览",
    "fill_count": "今日提交"
  },
  "tag": {
    "recently_active": "最近活跃",
    "recently_created": "最近创建",
    "desktop": "我的表单",
    "shared_forms": "与我共享",
    "favorites_forms": "我的收藏",
    "participated": "我为别人填写的表单",
    "trash": "回收站"
  },
  "empty": "还没有表单",
  "empty_shared_forms": "你尚未添加协作者或协作者还没有共享表单给你",
  "empty_participated": "还没有填写过的表单",
  "empty_search": "没有搜索到表单",
  "empty_trash": "回收站为空",
  "search": {
    "title": "搜索表单",
    "placeholder": "输入关键词搜索表单"
  }
}
